module.exports = __webpack_public_path__ + "static/dip-hero-mobile.76d527df.webp";